import { ZonedDateTime } from '@internationalized/date';
import {
  AssetSortOption,
  AssetStatus,
} from '@rematter/frontend-lib-api-client';

import { AssetRecord } from '~/modules/transportation/types';
import { createQueryHook } from '~/shared/providers/api';

export const useAssetsQuery = createQueryHook(
  'transportation.assets',
  (params: {
    ids?: string[];
    typeIds?: string[];
    status?: AssetStatus[];
    identifier?: string;
    accountId?: string;
    facilityIds?: string[];
    accountAddressIds?: string[];
    lastUpdatedAt?: ZonedDateTime;
    searchTerm?: string;
    limit?: number;
    offset?: number;
    sorting: AssetSortOption[];
  }) => ({
    assets: {
      __args: {
        filter: {
          accountId: params.accountId,
          identifier: params.identifier,
          ids: params.ids,
          lastUpdatedAt: params.lastUpdatedAt?.toAbsoluteString(),
          searchTerm: params.searchTerm,
          status: params.status,
          facilityIds: params.facilityIds,
          accountAddressIds: params.accountAddressIds,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        __scalar: true,
        lastLocationTime: true,
        currentLocation: {
          __scalar: true,
        },
        type: {
          __scalar: true,
        },
        account: {
          id: true,
          name: true,
        },
        accountAddress: {
          id: true,
          name: true,
        },
        facility: {
          id: true,
          facilityName: true,
        },
        customAttributes: true,
        tareWeight: {
          value: true,
          unit: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { assets: AssetRecord[]; total?: number } => ({
      assets: data?.assets.entries.map((it) => ({
        id: it.id,
        identifier: it.identifier,
        type: it.type,
        daysOnSite: 0,
        account: it.account ?? undefined,
        accountAddress: it.accountAddress ?? undefined,
        facility: it.facility ?? undefined,
        status: it.status,
        fillState: it.fillState,
        description: it.description ?? '',
        customAttributes: it.customAttributes ?? {},
        tareWeight: it.tareWeight
          ? { ...it.tareWeight, __typename: 'Weight' as const }
          : null,
      })),
      total: data?.assets.page.total ?? undefined,
    }),
  },
);
